import { OpenInNew } from '@mui/icons-material'
import { Box, Typography, alpha, useTheme } from '@mui/material'
import { Link } from 'react-router-dom'

import { TLink } from '~/features/settings/models'
import rem from '~/utils/ui'

function Item({ label, url }: TLink) {
  const theme = useTheme()
  return (
    <Box
      component={Link}
      to={url}
      target="_blank"
      sx={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        textDecoration: 'none',
        color: theme.palette.mainFont,
        gap: rem(8),
        '&:hover': {
          color: alpha(theme.palette.tertiary1, 0.7),
        },
      }}
    >
      <OpenInNew sx={{ fontSize: rem(12) }} />
      <Typography
        variant="subtitle1"
        sx={{
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          fontSize: rem(16),
        }}
      >
        {label}
      </Typography>
    </Box>
  )
}

export default Item
